import { ReferenceRangeDisplay } from "@/components/ReferenceRangeDisplay/ReferenceRangeDisplay";
import { BodyText, Button, HeaderText, Tooltip } from "@/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/Dropdown";
import { useBmi } from "@/features/Patient/PatientBar/network/useBmi";
import { useParams } from "@tanstack/react-router";
import { EllipsisVertical, RotateCcwClock } from "lucide-react";
import { useState } from "react";
import { BmiHistoryModal } from "./BmiHistoryModal";
import { VitalSkeleton } from "./VitalSkeleton";

export const BmiVital = () => {
  const { patientId } = useParams({ strict: false });
  const { data: bmiData, isLoading: isBmiLoading } = useBmi(patientId);
  const [isHistoryDialogOpen, setIsHistoryDialogOpen] = useState(false);

  if (isBmiLoading) return <VitalSkeleton title="BMI" showDateTime={false} />;

  const bmiValue = bmiData?.bmi;

  return (
    <>
      <div className="flex flex-col gap-2 px-3 py-2 relative">
        <div className="flex justify-between items-center">
          <HeaderText size="sm">BMI</HeaderText>
          <DropdownMenu>
            <Tooltip
              tooltipContentText="Options"
              side="bottom"
              triggerClassName="leading-[0px] pt-2 h-6"
            >
              <DropdownMenuTrigger asChild>
                <Button
                  variant="icon"
                  size="sm"
                  aria-label="Options for BMI"
                  className="m-0 p-0 h-4"
                >
                  <EllipsisVertical className="text-link" size={18} />
                </Button>
              </DropdownMenuTrigger>
            </Tooltip>
            <DropdownMenuContent align="start">
              <DropdownMenuItem onClick={() => setIsHistoryDialogOpen(true)}>
                <RotateCcwClock className="h-4 w-4 mr-2" />
                See History
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <BodyText size="sm" textColor="tertiary">
          <ReferenceRangeDisplay
            criticality={bmiData?.criticality ?? null}
            data={bmiValue ? String(bmiValue) : "N/A"}
            referenceRanges={bmiData?.referenceRanges ?? null}
            tooltipFallback=""
          />
        </BodyText>
      </div>
      {patientId && (
        <BmiHistoryModal
          open={isHistoryDialogOpen}
          onOpenChange={setIsHistoryDialogOpen}
          patientId={patientId}
        />
      )}
    </>
  );
};
